export default "__VITE_ASSET__TpV86tRu__"